





































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import SelectableEntity from '@/models/Shared/SelectableEntity'

// @ts-ignore
import VCurrencyField from 'v-currency-field';
import { component } from 'vue/types/umd';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import QuickBookRequest from '@/models/BookingRoleWorkers/QuickBookRequest';
import ShiftStatus from '@/models/Shifts/ShiftStatus';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import AvailabilityRestrictionSummary from '@/components/AvailabilityRestrictions/Display/AvailabilityRestrictionSummary.vue';
import CalculatePayRateForQuickBookRequest from '@/models/WorkerPositions/CalculatePayRateForQuickBookRequest';

@Component({
    name: 'BookingBrowseWorkersQuickBook', 
    components: { AvailabilityRestrictionSummary }
})
export default class extends GiganautVueDialog {

  @Prop()
  selectedBookingRole: BookingRoleDto;
  public shifts: SelectableEntity<ShiftDto>[] = [];
  public selectedShiftIds: string[] = [];
  public payRate = 0;
  public minimumPayRate = 0;
  public chargeRate = 0;
  public selectedWorker: WorkerProfileDto = null;
  public dialog = false;
  public dialogWidth = 600;
  public workerHasRestriction = false;
  public restrictionCheckRequired = false;
  public columns = "12";
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    this.selectedShiftIds = [];
    this.shifts = [];
    this.selectedWorker = null;
    BookingDetailsModule.browseWorkersVM.availabilitySummariesForQuickbook = [];
    if (val) {
      const nonCancelledShifts = BookingDetailsModule.selectedBookingRole.shifts.filter(
        shift => shift.status !== ShiftStatus.Cancelled
      )
      this.shifts = nonCancelledShifts.map(function(shift) {
        return new SelectableEntity<ShiftDto>(shift);
      });
      this.chargeRate = BookingDetailsModule.selectedBookingRole.chargeRate;
      await BookingDetailsModule.getWorkersForQuickBook();
    }
  }

  @Watch('selectedWorker')
  async onSelectedWorkerChanged(val: WorkerProfileDto, oldVal: WorkerProfileDto) {
    if (val === undefined || val === null) {
      this.resetForm();
      return;
    }

    //Get the latest shift in the list - that means the pay rate will be for the last available shift but not much we can do about that
    let latestShiftDate = this.shifts[0].entity.startAt;
    
    for (let shiftIndex = 0; shiftIndex < this.shifts.length; shiftIndex++) {
      const shift = this.shifts[shiftIndex];
      if (shift.entity.startAt > latestShiftDate) {
        latestShiftDate = shift.entity.startAt
      }
    }

    const payRateForQuickBookRequest = new CalculatePayRateForQuickBookRequest();
    payRateForQuickBookRequest.workerProfile = val;
    payRateForQuickBookRequest.date = new Date(latestShiftDate).toISOString().substr(0,10);
    await BookingDetailsModule.getWorkerPayRateForQuickBook(payRateForQuickBookRequest);
    this.payRate = BookingDetailsModule.browseWorkersVM.payRateForQuickBook;
    this.minimumPayRate = BookingDetailsModule.browseWorkersVM.minimumPayRateForQuickBook;
    if (val.availabilityRestriction !== AvailabilityRestriction.None) {
      this.workerHasRestriction = true;
      this.restrictionCheckRequired = true;
      this.dialogWidth = 1000;
      this.columns = "6";
    } else {
      this.workerHasRestriction = false;
      this.restrictionCheckRequired = false;
      this.dialogWidth = 600;
      this.columns = "12";
    }

  }

  resetForm() {
    this.workerHasRestriction = false;
    this.dialogWidth = 600;
    this.columns = "12";
    this.selectedShiftIds = [];
    this.selectedWorker = null;
    this.payRate = 0;
    this.minimumPayRate = 0;
  }

  async updateSelectedShifts(val: boolean, shift: ShiftDto) {
    if (val) {
			  this.selectedShiftIds.push(shift.id);
		} else {
			  const index = this.selectedShiftIds.indexOf(shift.id);
        this.selectedShiftIds.splice(index, 1); 
		}
    if (this.selectedShiftIds.length != 0) {
      if (this.workerHasRestriction) {
        this.restrictionCheckRequired = true;
      } else {
        this.restrictionCheckRequired = false;
      }
    }
	}

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get workers() {
    return BookingDetailsModule.browseWorkersVM.workersForQuickBook;
  }

  get summaries() {
    return BookingDetailsModule.browseWorkersVM.availabilitySummariesForQuickbook;
  }

  get isLessThanMinimumPayRate() {
    if (this.minimumPayRate === 0) {
      //Not much we can do about that - don't do the check
      return false;
    }
    return this.payRate < this.minimumPayRate;
  }

  calculateAge(dateOfBirth: Date){
		if (dateOfBirth === null) {
			return "Age Unknown";
		}
		const dob = new Date(dateOfBirth);
		const diff_ms = Date.now() - dob.getTime();
    	const age_dt = new Date(diff_ms); 
  
    	return (Math.abs(age_dt.getUTCFullYear() - 1970) < 18) ? "Under 18" : "";
	}
	  
  async confirm() { 
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new QuickBookRequest();
    request.payRate = this.payRate;
    request.chargeRate = this.chargeRate;
    request.shiftIds = this.selectedShiftIds;
    request.bookingRoleId = this.selectedBookingRole.id;
    request.workerId = this.selectedWorker.id;
    await BookingDetailsModule.quickBook(request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(this.selectedBookingRole);
    this.dialog = false;
  }

  async check() { 
    await BookingDetailsModule.getWorkerRestrictionSummaryForQuickBook(this.selectedShiftIds);
    this.restrictionCheckRequired = false;
  }
}
